import { CategoryData } from '../../../../types/types';

export const corps: CategoryData = {
    // Tête et visage
    'Moto (Tête)': {
        translation: 'Tête',
        translationEn: 'Head',
        illustration: '👤',
        audio: 'Li-moto'
    },

    'Elongi (Visage)': {
        translation: 'Visage',
        translationEn: 'Face',
        illustration: '👤'
    },
 'Liso (oeil)': {
        translation: 'Œil',
        translationEn: 'eye',
        illustration: '👁️'
    },
    'Mbunzu (front)': {
        translation: 'front',
        translationEn: 'forehead',
        illustration: '👁️'
    },

     'Matoyi (Les oreilles)': {
        translation: 'Les oreilles',
        translationEn: 'The ears',
        illustration: '👁️'
    },


     'Litoyi (L oreille)': {
        translation: 'L oreille',
        translationEn: 'The ear',
        illustration: '👁️'
    },

     'Mino (dents)': {
        translation: 'dents',
        translationEn: 'teeth',
        illustration: '👁️'
    },

     'Mandefu(barbe)': {
        translation: 'barbe',
        translationEn: 'beard',
        illustration: '👁️'
    },

      'Kingodi ngodi (gorges)': {
        translation: 'Gorge',
        translationEn: 'Throat',
        illustration: '👁️'
    },



    'Miso (Yeux)': {
        translation: 'Yeux',
        translationEn: 'Eyes',
        illustration: '👁️'
    },
     'Makiki (Sourcils)': {
        translation: 'Sourcils',
        translationEn: 'Eyebrows',
        illustration: '👁️'
    },
    'Zolo (Nez)': {
        translation: 'Nez',
        translationEn: 'Nose',
        illustration: '👃'
    },
    'Munoko (Bouche)': {
        translation: 'Bouche',
        translationEn: 'Mouth',
        illustration: '👄'
    },
     'Lolemo (Langue)': {
        translation: 'Langue',
        translationEn: 'Tongue',
        illustration: '👄'
    },
    'Matoyi (Oreilles)': {
        translation: 'Oreilles',
        translationEn: 'Ears',
        illustration: '👂'
    },
    'Suki (Cheveux)': {
        translation: 'Cheveux',
        translationEn: 'Hair',
        illustration: '💇'
    },
    'Mbanga (Machoire)': {
        translation: 'Mâchoire',
        translationEn: 'Jaw',
        illustration: '🦷'
    },
    // Membres
    'Makolo (Jambes)': {
        translation: 'Jambes',
        translationEn: 'Legs',
        illustration: '🦵'
    },

     'Libele (Sein)': {
        translation: 'Sein',
        translationEn: 'Breast',
        illustration: '🦵'
    },
    'Mabele (Seins)': {
        translation: 'Seins',
        translationEn: 'Breasts',
        illustration: '🦵'
    },
    'Maboko (Bras/Main)': {
        translation: 'Bras/Main',
        translationEn: 'Arm/Hand',
        illustration: '💪'
    },

     'Mosapi (Doigt)': {
        translation: 'Doigt',
        translationEn: 'Finger',
        illustration: '👆'
    },

    'Misapi (Doigts)': {
        translation: 'Doigts',
        translationEn: 'Fingers',
        illustration: '👆'
    },


    'Litambe (Pied)': {
        translation: 'Pied',
        translationEn: 'Foot',
        illustration: '🦶'
    },
    // Tronc
    'Libumu (Ventre)': {
        translation: 'Ventre',
        translationEn: 'Belly',
        illustration: '🫃'
    },

     'Motema (Coeur)': {
        translation: 'Cœur',
        translationEn: 'Heart',
        illustration: '🫃'
    },

    'Mipenzi (Cotes)': {
        translation: 'Cotes',
        translationEn: 'Ribs',
        illustration: '🫃'
    },
    'Mopenzi (Cote)': {
        translation: 'Cote',
        translationEn: 'Rib',
        illustration: '🫃',
        audio: 'Li-mopenzi'
    },
    'Libali (Foie)': {
        translation: 'Foie',
        translationEn: 'Liver',
        illustration: '🫃'
    },

     'Mitshopo (Intestins)': {
        translation: 'Intestins',
        translationEn: 'Intestines',
        illustration: '🫃'
    },


      'Motulu (Nombril)': {
        translation: 'Nombril',
        translationEn: 'Navel',
        illustration: '🫃'
    },
    'Tolo (Poitrine)': {
        translation: 'Poitrine',
        translationEn: 'Chest',
        illustration: '🫀'
    },

    'Kingo (Cou)': {
        translation: 'Cou',
        translationEn: 'Neck',
        illustration: '🫀'
    },

      'Lipeka (Epaule)': {
        translation: 'Epaule',
        translationEn: 'Shoulder',
        illustration: '🫀'
    },

     'Mapeka (Epaules)': {
        translation: 'Epaules',
        translationEn: 'Shoulders',
        illustration: '🫀'
    },


    'Mukongo (Dos)': {
        translation: 'Dos',
        translationEn: 'Back',
        illustration: '🦴'
    },
    'Loketo (Hanches)': {
        translation: 'Hanches',
        translationEn: 'Hips',
        illustration: ''
    },

     'Mipende (Cuisses)': {
        translation: 'Cuisses',
        translationEn: 'Thighs',
        illustration: ''
    },

     'Mabolongo (Genou)': {
        translation: 'Genou',
        translationEn: 'Knee',
        illustration: ''
    },

     'Makila (Sang)': {
        translation: 'Sang',
        translationEn: 'Blood',
        illustration: '👆'
    },


     'Misisa (Muscles)': {
        translation: 'Muscles',
        translationEn: 'Muscles',
        illustration: '👆'
    },

      'Makolo (Pied)': {
        translation: 'Pied',
        translationEn: 'Foot',
        illustration: ''
    },
};

export default corps;
